import { ReduxState } from 'src/store/types';

export const permissionsSelector = (state: ReduxState) =>
  state.connections.permissions;
